import React, { Suspense } from 'react';
import { Route } from 'react-router-dom';
import commonRoutesConfig from './config/commonRoutesConfig';
import Loader from '../components/Loader';

const CommonRoutes = commonRoutesConfig.map(({ path, component: Component }) => (
  <Route
    key={path}
    path={path}
    element={
      <Suspense fallback={<Loader />}>
        <Component />
      </Suspense>
    }
  />
));

export default CommonRoutes;
